import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { revertSurveyCompleted, setSurveyCompleted } from 'store/kits';

export const postSurveySubmitted = async ({
  tinyaccount_id,
  kit_id,
  form_id,
}: {
  tinyaccount_id: string;
  kit_id?: string;
  form_id: string;
}) => {
  const response = await API.post(
    apiName,
    `${apiBasePath}/tinyAccounts/${tinyaccount_id}/typeform_submit`,
    {
      form_id,
      kit_id: kit_id ?? null,
    },
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.SURVEYS,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        tinyAccountId: tinyaccount_id,
        kitId: kit_id,
        formId: form_id,
      },
    },
  );
  return response;
};
const useSubmitSurvey = () => {
  const dispatch = useDispatch();
  const trackEvent = useAnalytics().trackEvent;

  const submitSurvey = async (properties: {
    form_id: string;
    tinyaccount_id: string;
    kit_id?: string;
  }) => {
    try {
      //we log the event before to ensure it is logged even if the update fails
      trackEvent('Survey Completed', properties);
      //optimistic update
      dispatch(setSurveyCompleted(properties));
      await postSurveySubmitted(properties);
      toast.success('Survey Completed');
      return true;
    } catch (error) {
      //revert optimistic update
      dispatch(revertSurveyCompleted(properties));
      toast.error(
        'There was an error submitting the survey. Please try again.',
      );
    }
  };
  return submitSurvey;
};
export default useSubmitSurvey;
